import React from 'react'
import { font } from './constants'

function NextButton({ label, onClick, color = '#FF4B4F', icon = '→' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        width: '100%',
        padding: '16px 0',
        borderRadius: 10,
        border: 'none',
        marginTop: 24,
        background:
          color === '#C1D850'
            ? 'linear-gradient(135deg, #C1D850, #a8bf3a)'
            : `linear-gradient(135deg, ${color}, ${color}dd)`,
        color: '#fff',
        fontSize: 15,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: font,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        boxShadow: `0 4px 24px ${color}40`,
      }}
    >
      {icon} {label}
    </button>
  )
}

export default NextButton
